export default __webpack_public_path__ + "static/media/registration.af78f054.svg";